export default __webpack_public_path__ + "static/media/022-european union.8839a3ad.svg";